var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarrinho(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 64,
    viewBox: "0 0 70 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.26666 4.02966H15.4",
    stroke: "#303030",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4 4.02966L25.6667 44.8",
    stroke: "#303030",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5333 44.8H66.0333",
    stroke: "#303030",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2 60.9185C36.0661 60.9185 39.2 57.7349 39.2 53.8074C39.2 49.8802 36.0661 46.6963 32.2 46.6963C28.3339 46.6963 25.2 49.8802 25.2 53.8074C25.2 57.7349 28.3339 60.9185 32.2 60.9185Z",
    stroke: "#303030",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0333 60.9185C62.8992 60.9185 66.0333 57.7349 66.0333 53.8074C66.0333 49.8802 62.8992 46.6963 59.0333 46.6963C55.1672 46.6963 52.0333 49.8802 52.0333 53.8074C52.0333 57.7349 55.1672 60.9185 59.0333 60.9185Z",
    stroke: "#303030",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9667 34.6074H26.3667C24.9666 34.6074 23.5666 33.6592 23.3333 32.237L18.9 16.3556C18.4333 14.2222 19.8333 12.3259 21.9333 12.3259H64.1667C66.2667 12.3259 67.9 14.4593 67.2 16.3556L62.7667 32.237C62.7667 33.6592 61.6 34.6074 59.9667 34.6074Z",
    stroke: "#303030",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrinho);
export default __webpack_public_path__ + "static/media/carrinho.b96ac4151ae88b060775a6aa513da72a.svg";
export { ForwardRef as ReactComponent };